import { render, staticRenderFns } from "./nineGrid.vue?vue&type=template&id=a6f66fe6&scoped=true&"
import script from "./nineGrid.vue?vue&type=script&lang=js&"
export * from "./nineGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f66fe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6f66fe6')) {
      api.createRecord('a6f66fe6', component.options)
    } else {
      api.reload('a6f66fe6', component.options)
    }
    module.hot.accept("./nineGrid.vue?vue&type=template&id=a6f66fe6&scoped=true&", function () {
      api.rerender('a6f66fe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xcxPos/home/child/nineGrid.vue"
export default component.exports